// extracted by mini-css-extract-plugin
export default {"root":"CustomLink_root__mV1iU","disabled":"CustomLink_disabled__XcpDN"};